import React, { useState } from 'react'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'
import getCashRegisterLogs from '../../gql/getCashRegisterLogs'
import { useLazyQuery } from 'components/graphql'
import Button from 'components/Button'
import { Modal } from 'components/Modal'
import moment from 'moment'
import Divider from 'components/Divider'
import { ReactComponent as Terminal } from 'media/icons/terminal.svg'
import { DateTimePicker } from 'components/forms'
import { useQuery } from 'components/graphql'
import gql from 'graphql-tag'

const getCashRegisterQuery = gql`
	query getCashRegister($id: ID!) {
		cashAssist {
			getCashRegister(id: $id) {
				id
				hardwareId
				deviceType
				parameters {
					gloryTerminalConnected
				}
			}
		}
	}
`

const getMobileWaiterLogs = gql`
	query getMobileWaiterLogs($hardwareId: ID!, $date: DateTime!) {
		getMobileWaiterLogs(hardwareId: $hardwareId, date: $date) {
			link
		}
	}
`

const DownloadLogs = ({ deviceId, deviceName, isDisabled }) => {
	const [t] = useTranslation()
	const [openModal, setOpenModal] = useState(false)
	const [date, setDate] = useState(moment(new Date()).utc())
	const [showError, setShowError] = useState(false)
	const { data } = useQuery(getCashRegisterQuery, {
		variables: { id: deviceId },
		skip: !openModal
	})
	const cashRegister = data?.getCashRegister
	const gloryConnected = cashRegister?.parameters?.gloryTerminalConnected
	const hardwareId = cashRegister?.hardwareId
	const isMobileWaiter = cashRegister?.deviceType === 'MOBILE_WAITER'

	const [getLog, { loading }] = useLazyQuery(getCashRegisterLogs, {
		onCompleted: res => {
			const url = res?.getCashRegisterLogs?.link
			if(url === null) {
				return setShowError(true)
			}
			window.location.href = url
		},
		onError: error => error && setShowError(true)
	})
	const [getMobileWaiterLog, { loading: mobileWaiterLoading }] = useLazyQuery(getMobileWaiterLogs, {
		onCompleted: res => {
			const url = res?.getMobileWaiterLogs?.link
			if(url === null) {
				return setShowError(true)
			}
			window.location.href = url
		},
		onError: error => error && setShowError(true)
	})

	const handleGetLog = (logsType) => {
		setShowError(false)
		getLog({
			variables: {
				cashRegisterId: deviceId,
				date: date,
				logsType
			}
		})
	}
	const handleGetMobileWaiterLog = () => {
		setShowError(false)
		getMobileWaiterLog({
			variables: {
				hardwareId,
				date
			}
		})
	}

	return(
		<>
			<Button
				type='button'
				onClick={() => setOpenModal(true)}
				status={isDisabled ? 'inactive' : 'primary'}
				text={t('options_section.strings.download_log')}
			/>
			{openModal &&
				<Modal unmount={() => {
					setDate(moment(new Date()).utc())
					setOpenModal(false)
					setShowError(false)
				}}
				label={t('options_section.strings.download_log')}
				width={600}
				height={400}
				>
					<div style={{ display: 'flex', marginBottom: '15px' }}>
						<Terminal />
						<p style={{ marginLeft: '5px', fontSize: '17px' }}>{deviceName}</p>
					</div>
					<DateTimePicker
						noForm
						label={t('common.fields.from_date')}
						value={date}
						onChange={setDate}
					/>
					<Divider />
					{isMobileWaiter ? (
						<SButtonsContainer>
							<Button
								onClick={handleGetMobileWaiterLog}
								status={!date ? 'inactive' : 'primary'}
								loading={mobileWaiterLoading}
								text={t('options_section.strings.general_logs')}
								fWidth
							/>
						</SButtonsContainer>
					) : (
						<>
							<SButtonsContainer>
								<Button
									onClick={() => handleGetLog('general')}
									status={!date ? 'inactive' : 'primary'}
									loading={loading}
									text={t('options_section.strings.general_logs')}
									fWidth
								/>
								<Button
									onClick={() => handleGetLog('user')}
									status={!date ? 'inactive' : 'primary'}
									loading={loading}
									text={t('options_section.strings.user_logs')}
									fWidth
								/>
							</SButtonsContainer>
							<Divider />
							<SButtonsContainer>
								<Button
									onClick={() => handleGetLog('glory')}
									status={!date || !gloryConnected ? 'inactive' : 'primary'}
									loading={loading}
									text={t('options_section.strings.glory_logs')}
									fWidth
								/>
							</SButtonsContainer>
						</>
					)}
					{showError && <h2 style={{ color: '#dd5860', fontSize: '11px', marginTop: '16px' }}>{t('options_section.strings.not_existed_log')}</h2>}
				</Modal>
			}
		</>
	)
}

const SButtonsContainer = styled.div`
	display: flex;
	justify-content: space-between;
	button {
		flex-basis: 45%;
	}
`

export default DownloadLogs

